module.exports = __webpack_public_path__ + "media/images/profile_verification/victory_right-583049473cc77f16f409a4623df11e61.png";